import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from '@providers';
import { Routes } from './routes';

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppProviders>
        <Routes />
      </AppProviders>
    </BrowserRouter>
  );
}

export default App;
